// Angular
import { Component, OnInit } from '@angular/core';

// localforage
import * as localforage from 'localforage';

// services
import { ApiService } from '@app/services/api/api.service';

@Component({
  selector: 'oh-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit {
  public userCount: number;
  public openHouse: any;
  public signInStyle: string;
  public surveyURL: string;

  constructor(private apiService: ApiService) {}

  async ngOnInit() {
    localforage.removeItem('oh-active-user');
    localforage.removeItem('oh-survey-other-text');
    localforage.removeItem('oh-survey-select-answer');

    await this.getData();
    this.userCount = await this.apiService.getLogSignInCount(this.openHouse);
  }

  private async getData() {
    try {
      this.openHouse = await localforage.getItem('oh-selected-open-house');
    } catch (error) {
      console.error(error);
    }

    // Get the agent domain
    try {
      let agentData = await this.apiService.getAgentDataFromDatabase();
      this.signInStyle = agentData.guest_signin.style;
      this.surveyURL = "http://"+agentData.domain+"/shared/openhouseconnector/survey.php?openid="+this.openHouse.open_id;
    } catch (error) {
      console.error(error);
    }
  }
}
